export const APP_ROUTE_PATHS = [
  "/",
  "/offers",
  "/analytics",
  "/online-store",
  "/settings",
] as const;

export type AppRoute = (typeof APP_ROUTE_PATHS)[number];

export function appRouteFromPathname(pathname: string): AppRoute {
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return APP_ROUTE_PATHS.find((route) => route === normalized) ?? "/";
}
